import { MetabaseCard } from '@shared/components/metabase';

export class CustomerReportModel extends MetabaseCard {}
